import { Component } from '@angular/core';

import { CriticityComponent, CriticityStatus } from '@camelot/ui';

import { AbstractCellComponent } from '../../abstract';

@Component({
  host: { 'data-cid': 'grid-criticity-cell' },
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '',
  imports: [CriticityComponent],
  template: `<div class="align-center" style="height: 100%">
    <cam-criticity [criticity]="this.criticity"></cam-criticity>
  </div>`,
})
export class GridCriticityCellComponent extends AbstractCellComponent<unknown, CriticityStatus> {
  get criticity() {
    return this.value ?? CriticityStatus.Unknown;
  }
}
